import React from 'react';

const NotificationBanner = () => {
    return (
        <div className="relative top-20 w-full z-40 bg-primary text-white py-2 px-4 shadow-md">
            <div className="">
                <p className="text-center text-sm md:text-base font-medium">
                    Start Your Free Trial Today! Personalize learning for your team or classroom with AI
                </p>
            </div>
        </div>
    );
};

export default NotificationBanner; 